module.exports = __webpack_public_path__ + "img/logo.3bf3db51.png";